import styled from "styled-components";
import { COLORS, responsive } from "../../../styles/constants.style";

export const BulkInsertFooterWrapper = styled.div`
  margin: 16px 0px;
  background-color: ${COLORS.cirrus_white};
  padding: 32px 16px 20px;
  display: flex;
  justify-content: space-between;

  ${responsive.MOBILE`
    padding: 0px;
    flex-wrap: wrap;
    margin-top: 8px;

    .button-container {
      flex-direction: column-reverse;
      gap: 16px;
      justify-content: center;
      padding: 16px 8px;

      button {
        width: 100%;
        max-width: none;
      }
  }
    
    & > div {
      width: 100%;
      display: flex;
      justify-content: center;
      
      &:first-child {
        order: 2;
      }
      
      &:last-child {
        order: 1;
        margin-bottom: 8px;
      }
    }
  `}

  .btn-secondary {
    margin-right: 16px;
  }
`;
